<template>
  <div v-if="processState.processes.length > 0">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="orange" class="ma-2 fabclassD" dark fab fixed bottom right @click="showdownloadbar()">
          <v-icon dark> mdi-cloud-download </v-icon>
        </v-btn>
      </template>
      <span>Report(s)</span>
    </v-tooltip>
  </div>
</template>

<script>
import { USER_RPT_PROCESS_STATE } from '@/store/types'
export default {
  methods: {
    showdownloadbar() {
      if (this.processState.show === false) {
        this.$store.commit(USER_RPT_PROCESS_STATE, true)
        // this.processState.show = true
      } else if (this.processState.show === true) {
        this.$store.commit(USER_RPT_PROCESS_STATE, false)
        // this.processState.show = false
      }
    }
  },
  computed: {
    processState() {
      return this.$store.state.user.rptJob.rptProcess
    }
  }
}
</script>

<style lang="scss">
.fabClass.btn--bottom {
  bottom: 70px;
}
.fabclassD {
  bottom: 70px !important;
  right: 9px !important;
}
</style>
